import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 订单类型
 */
class OilOrderType extends UltMeta {
    SELF_ORDER = new Meta(1, "自行下单");

    PLATFORM_ORDER = new Meta(2, "平台代下");
}
export const OIL_ORDER_TYPE = new OilOrderType();

/**
 * 油品类型
 */
class OilType extends UltMeta {
    ZERO_DIESEL_FUEL = new Meta(1, "0号柴油");

    LIGHT_FUEL_OIL = new Meta(2, "轻质燃油");
}
export const OIL_TYPE = new OilType();

/**
 * 支付状态
 */
class OilOrderPayState extends UltMeta {
    UN_CONFIRM = new Meta(1, "待确认");
    SUCCESS = new Meta(2, "已支付");
}
export const OIL_ORDER_PAY_STATE = new OilOrderPayState();

/**
 * 支付状态
 */
class OilOrderState extends UltMeta {
    BOOKING = new Meta(1, "预约中");

    IN_PROGRESS = new Meta(2, "进行中");

    COMPLETED = new Meta(3, "已完成");

    CANCELED = new Meta(4, "已取消");
}
export const OIL_ORDER_STATE = new OilOrderState();

/**
 * 时间段
 */
class TimePeriod extends UltMeta {
    ONE = new Meta(1,"00:00-02:00");
    TWO = new Meta(2,"02:00-04:00");
    THREE = new Meta(3,"04:00-06:00");
    FOUR = new Meta(4,"06:00-08:00");
    FIVE = new Meta(5,"08:00-10:00");
    SIX = new Meta(6,"10:00-12:00");
    SEVEN = new Meta(7,"12:00-14:00");
    EIGHT = new Meta(8, "14:00-16:00");
    NINE = new Meta(9,"16:00-18:00");
    TEN = new Meta(10,"18:00-20:00");
    ELEVEN = new Meta(11,"20:00-22:00");
    IWELVE = new Meta(12,"22:00-24:00");
}
export const TIME_PERIOD = new TimePeriod();